//#region Imports

import { Component, Injector, ViewEncapsulation, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import * as _ from 'lodash-es';
import moment from 'moment';

import { Table } from 'primeng/table';
import { Paginator } from 'primeng/paginator';
import { LazyLoadEvent } from 'primeng/api';

import {
    OrderGuideServiceProxy,
    WebShopServiceProxy,
    CategoryServiceProxy,
} from '@shared/service-proxies/service-proxies';
import { NotifyService } from 'abp-ng2-module';
import { appModuleAnimation, PrimengTableHelper } from '@axilla/axilla-shared';

import { AppComponentBase } from '@shared/common/app-component-base';
import { WebshopService } from '@app/shared/common/shop-system/services/webshop.service';
import { AxillaPackage, BasketArticleExtendedDto } from '../../../../shared/common/shop-system/models/models';
//#endregion Imports

@Component({
    selector: 'app-confirm-order-summary',
    templateUrl: './confirm-order-summary.component.html',
    styleUrls: ['../../../dashboard/dashboard.component.less', './confirm-order-summary.component.less'],
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()]
})
export class ConfirmOrderSummaryComponent extends AppComponentBase implements OnInit, OnDestroy {

    constructor(
        injector: Injector,
        private orderGuideServiceProxy: OrderGuideServiceProxy,
        private categoryServiceProxy: CategoryServiceProxy,
        private webShopServiceProxy: WebShopServiceProxy,
        private _notifyService: NotifyService,
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private route: ActivatedRoute,

        private _webshopService: WebshopService
    ) {
        super(injector);
    }
    get package(): AxillaPackage {
        if (!this._package) {
            this._package = this._webshopService.package;
        }

        return this._package;
    }
    set package(value: AxillaPackage) {
        this._package = value;
    }

    //#endregion Additional Articles

    //#region Agreements

    get agreements() {
        return this._webshopService.agreements;
    }

    //#endregion Agreements

    //#region Total
    get total() {
        return this._webshopService.totalItemAmount + this.restTotal;
    }


    get restTotal(): number {
        let total = 0;
        if (this.ifAdditionalPRopertiesAvailable()) {
            let additionalTotal = 0;
            this._webshopService.additionalArticles.forEach((item) => {
                additionalTotal += item.quantity * item.price;
            });

            total += additionalTotal;
        }

        let deliveryTotal = this._webshopService.selectedDelivery.price;
        total += deliveryTotal;

        return total;
    }

    @ViewChild('dataTable', { static: true }) dataTable: Table;
    @ViewChild('paginator', { static: true }) paginator: Paginator;


    private _package: AxillaPackage;



    //#region Bastet overview




    updateBasketSubscription$;

    //#endregion Bastet overview

    //#region Delivery

    deliveryPrimengTableHelper: PrimengTableHelper;
    @ViewChild('deliveryDataTable', { static: true }) deliveryDataTable: Table;
    @ViewChild('deliveryPaginator', { static: true }) deliveryPaginator: Paginator;

    //#endregion Delivery

    //#region Additional Articles

    additionalArticlePrimengTableHelper: PrimengTableHelper;
    @ViewChild('additionalArticleDataTable', { static: true }) additionalArticleDataTable: Table;
    @ViewChild('additionalArticlePaginator', { static: true }) additionalArticlePaginator: Paginator;


    ngOnInit(): void {
        if (!this.basket || this.basket.length === 0) {
            this._webshopService.initBasket();
        }

        this._onBasketUpdate();

        this.deliveryPrimengTableHelper = new PrimengTableHelper();
        this.additionalArticlePrimengTableHelper = new PrimengTableHelper();

        this.setDataTable();
        this.setDeliveryDataTable();
        this.setAdditionalArticlesDataTable();
    }

    ngOnDestroy(): void {
        this.updateBasketSubscription$.unsubscribe();
    }
    private _onBasketUpdate() {
        this.updateBasketSubscription$ = this._webshopService.basketUpdate$
            .subscribe((items: BasketArticleExtendedDto[]) => {
                this.setDataTable();
            });
    }


    getBasket(event?: LazyLoadEvent) {
        this.setDataTable();
    }

    setDataTable() {
        if (this.basket || this.basket.length >= 0) {
            this.primengTableHelper.records = this.basket;
            this.primengTableHelper.totalRecordsCount = this.basket.length;
        }
    }

    changeAmountInBasket(article: BasketArticleExtendedDto) {
        this._changeAmountInBasket(article);

    }

    private _changeAmountInBasket(article: BasketArticleExtendedDto) {
        if (+article.quantity <= 0) {
            this.notify.info('Item quantity = 0, change ');
            return;
        }

        const item = _.cloneDeep(article);
        this._webshopService.changeItem(item);
    }

    confirmChangingItemCount(article: BasketArticleExtendedDto) {
        //this.changeAmountInBasket(article);
    }

    remove(item: BasketArticleExtendedDto) {
        if (item) {
            this._webshopService.remove(item);
        }
    }

    getBasketTotal(): number {

        let total = 0;
        _.forEach(this.basket, (item: BasketArticleExtendedDto) => {
            total += item.price * item.quantity;
        });

        return total;
    }

    getDelivery(event?: LazyLoadEvent) {
        this.setDeliveryDataTable();
    }

    setDeliveryDataTable() {
        if (this._webshopService.selectedDelivery) {
            let deliveries = [];
            deliveries.push(this._webshopService.selectedDelivery);

            this.deliveryPrimengTableHelper.records = deliveries;
            this.deliveryPrimengTableHelper.totalRecordsCount = 1;
        }
    }

    getDeliveryDate(type) {
        if (type === 'DELIVERY1') {
            return moment(moment(), 'DD-MM-YYYY').add(7, 'days');
        } else {
            return moment(moment(), 'DD-MM-YYYY').add(4, 'days');
        }
    }

    getDeliveryTotal() {
        return this._webshopService.selectedDelivery.price;
    }

    getAdditionalArticles(event?: LazyLoadEvent) {
        this.setDeliveryDataTable();
    }

    setAdditionalArticlesDataTable() {
        if (this._webshopService.additionalArticles) {

            this.additionalArticlePrimengTableHelper.records = this._webshopService.additionalArticles;
            this.additionalArticlePrimengTableHelper.totalRecordsCount = this._webshopService.additionalArticles.length;
        }
    }

    ifAdditionalPRopertiesAvailable(): boolean {
        if (this._webshopService.additionalArticles.length > 0) { return true; }

        return false;
    }

    getDocumentTotal(): number {

        let total = 0;
        _.forEach(this._webshopService.additionalArticles, (item: any) => {
            total += item.price * item.quantity;
        });

        return total;
    }


    ifAgreementsAvailable(): boolean {
        if (this._webshopService.additionalArticles.length > 0) { return true; }

        return false;
    }


    acceptAgreement(agreement: any) {
        this._webshopService.acceptAgreement(agreement);
    }
    //#endregion Total
}

